import { Box, Flex, Text } from "@chakra-ui/react";
import moment from "moment-timezone";
import { pad_with_zeroes } from "network/helper";

export default function OrderInfoCard(props: { selectedOrder: any }) {
  const { selectedOrder } = props;

  return (
    <Box bg="#FFFFFF" border="1px solid #E5E7EB" borderRadius="12px" overflow="hidden">
      <Box px="16px" py="14px" borderBottom="1px solid #E5E7EB">
          <Text fontSize="16px" fontWeight="600" color="#0B0E10">
            Info
          </Text>
        </Box>

        <Flex justify="space-between" align="center" px="16px" py="12px" borderBottom="1px solid #E5E7EB">
          <Text fontSize="14px" color="#111827">
            Project #
          </Text>
          <Text fontSize="14px" fontWeight="600" color="#111827">
            {pad_with_zeroes(selectedOrder.order_id, 6)}
          </Text>
        </Flex>

        <Flex justify="space-between" align="center" px="16px" py="12px" borderBottom="1px solid #E5E7EB">
          <Text fontSize="14px" color="#111827">
            Translation type
          </Text>
          <Text fontSize="14px" fontWeight="600" color="#111827" textTransform="capitalize">
            {selectedOrder.translation_type}
          </Text>
        </Flex>

        {selectedOrder.translation_type === "certified" && (
          <Flex justify="space-between" align="center" px="16px" py="12px" borderBottom="1px solid #E5E7EB">
            <Text fontSize="14px" color="#111827">
              Total page count
            </Text>
            <Text fontSize="14px" fontWeight="600" color="#111827">
              {selectedOrder.page_count || 0}
            </Text>
          </Flex>
        )}

        {selectedOrder.translation_type === "standard" && (
          <Flex justify="space-between" align="center" px="16px" py="12px" borderBottom="1px solid #E5E7EB">
            <Text fontSize="14px" color="#111827">
              Total word count
            </Text>
            <Text fontSize="14px" fontWeight="600" color="#111827">
              {selectedOrder.words_count || 0}
            </Text>
          </Flex>
        )}

        <Flex justify="space-between" align="center" px="16px" py="12px" borderBottom="1px solid #E5E7EB">
          <Text fontSize="14px" color="#111827">
            Language
          </Text>
          <Text fontSize="14px" fontWeight="600" color="#111827" textAlign="right" maxW="60%">
            {`${selectedOrder?.translated_from || "English"} → ${selectedOrder?.translated_to || "English"}`}
          </Text>
        </Flex>

        <Flex justify="space-between" align="center" px="16px" py="12px" borderBottom="1px solid #E5E7EB">
          <Text fontSize="14px" color="#111827">
            Due date
          </Text>
          <Text fontSize="14px" fontWeight="600" color="#111827" textAlign="right">
            {selectedOrder?.order_due_at
              ? moment(new Date(selectedOrder.order_due_at)).format("MMM. DD - hh:mm a")
              : "-"}
          </Text>
        </Flex>

        <Flex justify="space-between" align="center" px="16px" py="12px">
          <Text fontSize="14px" color="#111827">
            Order total
          </Text>
          <Text fontSize="14px" fontWeight="600" color="#111827">
            ${selectedOrder?.order_total || 0}
          </Text>
        </Flex>
    </Box>
  );
}
